export function markdownToHtml(markdown: string, options: { paragraphs: boolean } = { paragraphs: false }): string {
    let result = markdown
        .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>') // bold
        .replace(/\*(.*?)\*/g, '<i>$1</i>') // italic
        .replace(/~~(.*?)~~/g, '<s>$1</s>') // strikeout
        .replace(/__(.*?)__/g, '<u>$1</u>'); // underline

    if (options.paragraphs) {
        result = result.replace(/\n/g, '<br />');
    }

    return result;
}

export function flattenText(text: string, removeAccents: boolean = false): string {
    // Remove all non-alphanumeric characters, newlines and underscores (but since we need all languages, we leave all cyrillic, arabic, chinese and other non-latin language-related characters)
    let result = text.toLowerCase().replace(/\n/g, ' ').replace(/_/g, ' ').replace(/[^\w\s]/g, ' ').replace(/\s+/g, ' ').trim();

    if (removeAccents) {
        // remove all accented characters
        result = result.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    // Strip non-visible unicode spaces, expect for the regular space bar    
    result = result.replace(/[\u200B-\u200D\uFEFF]/g, '');

    return result;
}

export function removePunctuation(text: string): string {
    return text.replace(/[^\w\s]/g, '');
}

export function lowerAndRemovePunctuation(text: string): string {
    return text.toLowerCase().replace(/[^\w\s]/g, '');
}

export function countWords(text: string, language: string): number {
    if (language === 'chinese') {
        return text.replace(' ', '').length;
    } else {
        return text.split(' ').filter(word => word.length > 2).length;
    }
}

// Returns true if the text contains only numbers and/or punctuation
export function isNumerosymbolic(text: string): boolean {
    return text.match(/^\d+$/) !== null || text.match(/^[^\w\s]+$/) !== null;
}

export function capitalizeFirstLetters(text: string): string {
    return text.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export const basicLatinToDeftong = {
    'ä': 'a',
    'å': 'a',
    'á': 'a',
    'à': 'a',
    'é': 'e',
    'è': 'e',
    'í': 'i',
    'ì': 'i',
    'ó': 'o',
    'ò': 'o',
    'ú': 'u',
    'ù': 'u',
    'ü': 'u',
    'ñ': 'n',
    'ç': 'c',
    'ß': 'ss',
    'ø': 'o',
    'æ': 'ae',
    'œ': 'oe',    
}

export function transliterateToBasicLatin(text: string): string {
    return text.replace(/[áéíóúñüçßøæœåä]/g, (match) => {
        return basicLatinToDeftong[match];
    });
}

export function stripEmojis(text: string): string {
    // Source - https://stackoverflow.com/a
    text = text.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');

    return text;
}